export class ListDataCatalogsResponse {
    'catalogs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogs",
            "baseName": "catalogs",
            "type": "Array<DataCatalog>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
